const dataConstant = {
  APIStatus: {
    Success: "Success",
    Failure: "Failure",
  },
  dateFormatWithTime: "M/D/YYYY HH:mm",
  centralAmericaTimeZone: "America/Chicago",
  dateFormat: "YYYY-MM-DD",
  dateFormatUSFormat: "MM/DD/YYYY",
  passwordRegex:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,16}$/,
  roles: {
    admin: "Admin",
    staff: "Staff",
    marketer: "Marketer",
  },
  ErnieSignImageUrl: "Signature_Images/Ernie_Sign.png",
  inclementPolicy: "Inclement Weather Policy",
  inclementPolicyDescription:
    "In the event of extreme weather, reasonable efforts will be made for caregivers to arrive to their scheduled shifts. Should travel be deemed unsafe, in the Company's sole discretion, for the safety of our staff, the Company reserves the right to cancel shifts at no cost to the Client. Should a caregiver be willing to travel to a shift, but feel uncomfortable driving themselves a rideshare service (ex: Uber or Lyft) can be arranged by a Cambridge Scheduler. That ride share cost will be applied to the Client's next bill.",
};

export default dataConstant;
